export const downloadReport = (response) => {
    if (!response || !response.data) {
      throw new Error("Failed to fetch the report.");
    }
  
    // Create a Blob from the binary data in the response
    const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
    // Create a temporary download link for the Blob
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
  
    // Extract the filename from the response headers or use a default name
    const contentDisposition = response.headers['content-disposition'];
    const fileName = contentDisposition
      ? contentDisposition.split("filename=")[1].replace(/"/g, "")
      : "default-report.xlsx"; // Default filename
  
    // Set the download attribute to the file name
    link.setAttribute("download", fileName);
  
    // Trigger the download and remove the link afterward
    document.body.appendChild(link);
    link.click();
    link.remove();
  };
  